
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlaylistVideosComponent } from './playlist-videos.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [PlaylistVideosComponent],
  imports: [CommonModule, RouterModule],
  exports: [PlaylistVideosComponent] // Exporta o componente para ser usado em outros módulos
})
export class PlaylistModule {}